/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-by-video': {
    width: 20,
    height: 12,
    viewBox: '0 0 20 12',
    data: '<path pid="0" d="M18.612.816l-4.022 2.26v-.73a2.32 2.32 0 00-.703-1.659A2.428 2.428 0 0012.19 0H2.4C1.764 0 1.153.247.703.687A2.32 2.32 0 000 2.347v7.306c0 .623.253 1.22.703 1.66.45.44 1.06.687 1.697.687h9.79c.636 0 1.247-.247 1.697-.687a2.32 2.32 0 00.703-1.66v-.73l4.022 2.261c.762.429 1.388.077 1.388-.782v-8.8c0-.863-.624-1.215-1.388-.786z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
